import { Component, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Receipt } from 'app/shared/types/receipt';
import { ActivatedRoute, Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { ReceiptService } from 'app/shared/services/receipt.service';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { AuthService } from 'app/shared/services/auth.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { map, startWith} from 'rxjs/operators';
import { Observable} from 'rxjs';
import { NbThemeService } from '@nebular/theme';
import { DecimalPipe } from '@angular/common';
import * as moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css']
})
export class ReceiptComponent implements OnInit {


  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;
  filteredCustomerList: Observable<any[]>;
  customerList : any[];
  
  bankAccountList : any[];
  invoiceList : any[];
  unpaidinvoiceList : any[];

  receipt:Receipt;
  receiptData = [];
  updateReceiptData = [];
  receiptForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isBtnDisabled : boolean= false;
  isShowAttachBtn: boolean=false;
  isValidFormData: boolean = true;
  isfieldAmountReadOnly: boolean = true;
  showProcessingIndicator =false;
  panelTitle ="Receipt";
  companyData : any  = [];
  logo :any;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  PMT_TYPE =[
    {value: 'Cash'},
    {value: 'Cheque'},
    {value: 'Card Payment'},
    {value: 'Bank Transfer'},

  ];


  validationMessages = {
    'receiptNo': { 'required': 'Receipt number is required' },
    'paidDate': { 'required': 'Payment date is required' }, 
    'paymentType': { 'required': 'Payment Type is required' }, 
    'cusId': {'required': 'Customer Id is required' },
    'cusName': {'required': 'Customer is required' },
    'address': {'required': 'Address is required' },
    'depositAccount': {'required': 'Deposit Account is required' },
  };

  formErrors = {
    'receiptNo': "",
    'paidDate': "",
    'paymentType' : "",
    'cusId':"",
    'cusName': "",
    'address': "",
    'depositAccount': "",
  };


  constructor(private fb: FormBuilder,
        private receiptService: ReceiptService,
        private invoiceService: InvoiceService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private route : ActivatedRoute,
        private customerService : CustomerService,    
        private router : Router, 
        private themeService: NbThemeService,
        private fileUploadService:FileUploadService,
        private decimalPipe: DecimalPipe,
        private companyProfileService: CompanyProfileService,
        private bankAccountsService: BankAccountsService)
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD'
          });



      }

  ngOnInit() {
  
      this.initReceiptType();
      this.initFormFields();
      this.getControlPermissions();
       this.getCompanyDetails();

      this.isBtnDisabled = true; 
      this.getCustomerList();
      this.viewReceiptById();
      this.getBankAccountList();
      this.getAllInvoices();
      this.disableForm();
      this.viewInvoiceById();

      this.autoComplete();

      this.receiptForm.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.receiptForm);
        });

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });

  }// end oninit

  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }

  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{

                this.companyData = data;   
                this.loadLogo();         

                },
      (err) => {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      }
    );
  
  }
  
 


  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='RECEIPT'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  autoComplete(){
    this.filteredCustomerList = this.receiptForm.get('cusName').valueChanges
    .pipe(
      startWith(''),
      map(value => this._filterCustomer(value))
    );

  }

  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.GuestName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  getCustomerList(){
    this.customerService.getAll()
     .subscribe(
        (data) => {
                  this.customerList = data.filter((el)=>{
                    return el.Status !=="Deactivated";
                  });             
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

     getCustomerDetails(){      
      var filteredData;
      var cusName = this.receiptForm.value.cusName;
      if(cusName){
      filteredData = this.customerList.filter(data =>data.GuestName.toLowerCase()===cusName.toLowerCase());
       if(filteredData.length ===1){
         this.receiptForm.patchValue({
           cusId : filteredData[0].GuestId,
           address :filteredData[0].Address,
         });
       }else{
        this.receiptForm.patchValue({
          cusId : null,
          address :null,
        });

       }
      }
   }

       getBankAccountList(){
        this.bankAccountsService.getAllBankAccounts()
         .subscribe(
            (data) => {  
                      this.bankAccountList = data           
                      },
           (err) => 
                    {
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    });  
           
         }

    getAllInvoices(){
      this.invoiceService.getAll()
       .subscribe(
          (data) => {
                    this.invoiceList = data;           
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }


      getOutstandingInvoices(cusId, myArray){
        this.unpaidinvoiceList = [];
        for (let i=0; i < myArray.length; i++) {
          if (myArray[i].GuestId === cusId && (myArray[i].Status === 'Unpaid' || myArray[i].Status === 'Partially paid')) {
            this.unpaidinvoiceList.push(myArray[i]);
          }         
        }
        return this.unpaidinvoiceList;
      }
      


  initReceiptType() : void{

    this.receipt = {
      receiptNo: '',
      paidDate: '',
      paymentType: '',
      cusId: '',
      cusName: '',
      address: '',  
      depositAccount: '',  
      payRefNo: '',  
      paidTotal: 0.00,
      invoiceDate: '',
      invoiceNo: '',
      invoiceTotal: 0.00,
      balToPay: 0.00,
      accBalToPay : 0.00,
      amountPaid: 0.00,
      accAmountPaid : 0.00,     
      status : '',
      createdBy : '',
    };
  }

  initFormFields() : void{
    this.receiptForm = this.fb.group({
      receiptNo : ['',Validators.required],
      paidDate : ['',Validators.required],
      paymentType : [null,Validators.required],
      cusId :['',Validators.required],
      cusName : [null,Validators.required],
      address : ['',Validators.required],
      depositAccount : [null,Validators.required],
      payRefNo : [''],
      paidTotal : [''],
      unpaidInvoices : this.fb.array([]), 
       
    });


  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.isBtnDisabled = false;
    this.isShowAttachBtn=false;
    this.receiptForm.reset();
    this.getUnpaidInvoices.clear();
    this.enableForm();
    this.getMaxId();
    this.receiptForm.patchValue({
      paidDate:  this.defaultDate
    });
     
   }

   getMaxId(){
    var receiptNo = 0;
    var receiptNoPrefixZero  : String;
  
    this.receiptService.getMaxId()
    .subscribe(
      (res) => {
          receiptNo = Number(res[0].ReceiptNo) + 1;
          receiptNoPrefixZero = receiptNo.toString().padStart(6,'0');       
          this.receiptForm.patchValue({
            receiptNo : "CPMT" + receiptNoPrefixZero
          });
         
      },        
      (err) =>  {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
          }, 
      )

   }
  
   loadUnpaidInvoices(data) :FormArray{   
      const unpaidInvoiceArray = new FormArray([]);
      for(let i =0; i < data.length;i++){ 
        unpaidInvoiceArray.push(this.fb.group({
          invoiceDate : [moment(data[i].InvoiceDate).format("YYYY-MM-DD")],
          invoiceNo : [data[i].InvoiceNo],
          invoiceTotal : [data[i].GrandTotal],
          balToPay : [data[i].BalToPay],
          accAmountPaid : [data[i].AmountPaid],
          amountPaid : [],
          select : [false],    
        }));
      }
      return unpaidInvoiceArray;
      
   }

    selectInvoiceCheckBoxChange(event,i){
      if(event.checked){
        this.isfieldAmountReadOnly = false;
        var value = this.getUnpaidInvoices.value[i].balToPay
        this.getUnpaidInvoices.at(i).patchValue({amountPaid : value})
      }
      else{
        this.getUnpaidInvoices.at(i).patchValue({amountPaid : ''})
        this.isfieldAmountReadOnly = true;
      }

      this.updatePaymentTotal();

    }

    isNumeric(value) {
      if (!isNaN(value) &&  !isNaN(parseFloat(value))) {
        return true;
      }
       return false;

    }


    amountPaidFieldFocusOut(i) {
      const value = this.getUnpaidInvoices.value[i].amountPaid;
      if (value == 0 || !this.isNumeric(value)) {
        this.getUnpaidInvoices.at(i).patchValue({amountPaid : ''});
        this.getUnpaidInvoices.at(i).patchValue({select : false});
        this.isfieldAmountReadOnly = true;
      }

      this.updatePaymentTotal();
     }

   get getUnpaidInvoices(){
      return this.receiptForm.get('unpaidInvoices') as FormArray;
   }

   loadInvoiceButtonClick() : void {
    this.getUnpaidInvoices.clear();
    var cusId = this.receiptForm.value.cusId
      if(cusId){
       var data= this.getOutstandingInvoices(cusId, this.invoiceList);
          if(data.length > 0){
              this.receiptForm.setControl('unpaidInvoices',this.loadUnpaidInvoices(data));           
          }else{
            this.toastr.warning('No outstanding invoices for this customer.','Warning');
          }
      }else{
        this.toastr.warning('Customer Not Selected.','Warning');
      }

  }

    removeItemButtonClick(itemIndex : number) : void{
      this.getUnpaidInvoices.removeAt(itemIndex);
      this.updatePaymentTotal()
    }


    updatePaymentTotal(){
        var totalAmount = (this.getUnpaidInvoices.value.reduce((prev,curr)=>prev + +curr.amountPaid, 0)).toFixed(2);
        this.receiptForm.patchValue({
          paidTotal : totalAmount
        });
     }


  mapFormValuesToModel(){
    this.receiptData =[];
    this.updateReceiptData =[];
    var result = [];
    var updateResult = [];

    for(let i=0; i < this.getUnpaidInvoices.length; i++){

      var isChecked =this.getUnpaidInvoices.value[i].select;

      if(isChecked){

        this.receipt.receiptNo=this.receiptForm.value.receiptNo;
        this.receipt.paidDate=this.receiptForm.value.paidDate;
        this.receipt.paymentType=this.receiptForm.value.paymentType;
        this.receipt.cusId=this.receiptForm.value.cusId;
        this.receipt.cusName=this.receiptForm.value.cusName;
        this.receipt.address = this.receiptForm.value.address;
        this.receipt.depositAccount= this.receiptForm.value.depositAccount;
        this.receipt.payRefNo=this.receiptForm.value.payRefNo;
        this.receipt.paidTotal = this.receiptForm.value.paidTotal;
       
        this.receipt.invoiceDate=this.getUnpaidInvoices.value[i].invoiceDate;
        this.receipt.invoiceNo=this.getUnpaidInvoices.value[i].invoiceNo;
        this.receipt.invoiceTotal=this.getUnpaidInvoices.value[i].invoiceTotal;       
        this.receipt.balToPay=this.getUnpaidInvoices.value[i].balToPay;         
        this.receipt.amountPaid=this.getUnpaidInvoices.value[i].amountPaid;
        this.receipt.accBalToPay= this.receipt.balToPay -  this.receipt.amountPaid;
        this.receipt.accAmountPaid = +this.getUnpaidInvoices.value[i].accAmountPaid + +this.receipt.amountPaid;
        this.receipt.createdBy =this.authService.getUserLoggedIn();

            if (this.receipt.balToPay == this.receipt.amountPaid)
            {
              this.receipt.status = "Paid";
            }
            else if (this.receipt.balToPay > this.receipt.amountPaid)
            {
              this.receipt.status = "Partially paid";
            }
            else
            {
              this.receipt.status = "Unpaid";
            }
     
        
        this.receiptData.push(
              this.receipt.receiptNo,
              this.receipt.paidDate,
              this.receipt.paymentType,
              this.receipt.cusId,
              this.receipt.cusName,
              this.receipt.address,
              this.receipt.depositAccount,
              this.receipt.payRefNo,
              this.receipt.paidTotal,
              this.receipt.invoiceDate,
              this.receipt.invoiceNo,
              this.receipt.invoiceTotal,
              this.receipt.balToPay,
              this.receipt.amountPaid,
              this.receipt.status,
              this.receipt.createdBy,       
          );

          this.updateReceiptData.push(
            this.receipt.accBalToPay,
            this.receipt.accAmountPaid,
            this.receipt.status,
            this.receipt.invoiceNo,
            this.receipt.cusId,
          );

        } //////// end if

    }  /////// end loop

    while(this.receiptData.length){
      result.push(this.receiptData.splice(0,16));
      updateResult.push(this.updateReceiptData.splice(0,5));
    }

    return [result,updateResult];

  }

  getBalToPayAndAmountPaid(invoiceNo,cusId, myArray){
    for (let i=0; i < myArray.length; i++) {
      if (myArray[i].InvoiceNo === invoiceNo && myArray[i].GuestId === cusId) {
       return myArray[i];
      } 

    }

  }

  mapCancelReceiptDataToModel(){
    var cumBalToPay = 0;
    var cumSmountPaid = 0;
    
    this.updateReceiptData =[];
    var updateResult = [];
    

    for(let i=0; i < this.getUnpaidInvoices.length; i++){

      if(this.getUnpaidInvoices.length > 0){

       this.receipt.cusId=this.receiptForm.value.cusId;
        this.receipt.invoiceNo=this.getUnpaidInvoices.value[i].invoiceNo;  
        this.receipt.invoiceTotal=this.getUnpaidInvoices.value[i].invoiceTotal; 
       
        const getBal= this.getBalToPayAndAmountPaid(this.receipt.invoiceNo,this.receipt.cusId, this.invoiceList);
         cumBalToPay  = getBal.BalToPay;
         cumSmountPaid = getBal.AmountPaid;

         this.receipt.balToPay= +cumBalToPay + +this.getUnpaidInvoices.value[i].amountPaid;        
         this.receipt.amountPaid= +cumSmountPaid - +this.getUnpaidInvoices.value[i].amountPaid;


        if (this.receipt.invoiceTotal == this.receipt.balToPay)
        {
            this.receipt.status = "Unpaid";     
        }
        else if(this.receipt.invoiceTotal > this.receipt.balToPay)
        {
          this.receipt.status = "Partially paid";
        }

          this.updateReceiptData.push(
            this.receipt.balToPay,
            this.receipt.amountPaid,
            this.receipt.status,
            this.receipt.invoiceNo,
            this.receipt.cusId,
          );

        } //////// end if

    }  /////// end loop


    while(this.updateReceiptData.length){
      updateResult.push(this.updateReceiptData.splice(0,5));
     
    }

    return updateResult;

  }
  saveButtonClick(): void {
    this.logValidationErrors(this.receiptForm,true);
    const [data,updateData] = this.mapFormValuesToModel();

    const body = {dataInput : data, updateInput : updateData}
    if(this.isFilledFromFields()){
        this.showProcessingIndicator = true;
          this.receiptService.addReceipt(body)
          .subscribe(
            (res) =>{
              if(res.success === 0){
                this.receiptForm.patchValue({
                  receiptNo : res.autoId
                });
              this.saveButtonClick();
              this.showProcessingIndicator = false; 
            }else if(res.success === 1){
              this.toastr.success('Receipt posted successfully','Success');
              console.log(res);
              this.isfieldReadOnly  = true;
              this.isBtnDisabled = true;
              this.isShowAttachBtn = true;
              this.disableForm(); 
              this.showProcessingIndicator = false;  
              this.getAllInvoices();     
            }   
         
            },
            (err) =>{
              this.toastr.error('Failed to post  receipt','Failure'); 
              this.showProcessingIndicator = false; 
              this.getAllInvoices();  
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err); 
            }
          );
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;   
          this.getAllInvoices();                                                                                                                                                                                                 
        }

      
   }

   deleteButtonClick(){
    var receiptNo = this.receiptForm.get('receiptNo').value;
    if(receiptNo){
    this.dialogService.openConfirmDialog('Are you sure you want to delete this Receipt?')
    .afterClosed().subscribe(res =>{
      if(res){
    const data = this.mapCancelReceiptDataToModel();
    this.receiptService.deleteReceipt(data,receiptNo)
    .subscribe(
      (res) => {
                  if(res) {
                    this.toastr.success('Receipt deleted successfully','Success');
                    this.newButtonClick();
                    console.log(res); 
                    this.getAllInvoices();                       
                    }
                    else{
                      this.toastr.error('Failed to delete receipt','Failure');
                      this.getAllInvoices();                    
                    }                  
                },        
      (err) =>  {
                  this.toastr.error('Failed to delete receipt','Failure');
                  console.log(err);
                  this.getAllInvoices(); 
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
        );
     } 
   });

  }
 
}


   enableForm():void{
    Object.keys(this.receiptForm.controls).forEach(key => {
      this.receiptForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.receiptForm.controls).forEach(key => {
      this.receiptForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.receiptForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.receiptForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getUnpaidInvoices.length==0){
          return false;
          }

        return true;
  }

 



    viewReceiptById(){
        var hasReceiptNo;
        var receiptNo;

        hasReceiptNo =this.route.snapshot.queryParamMap.has('receiptNo');
         
          if(hasReceiptNo){
            receiptNo = this.route.snapshot.queryParamMap.get('receiptNo')
            this.receiptService.getReceipt(receiptNo)
            .subscribe(
              (data) => {
                        if(data){
                          this.patchValuesToForm(data); 
                          this.disableForm(); 
                          this.isfieldReadOnly = true;
                          this.isBtnDisabled = true;    
                          this.isShowAttachBtn = true;                
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }

    }

patchValuesToForm(data){

  this.receiptForm.patchValue({  

    receiptNo : data[0].ReceiptNo,
    paidDate :  moment(data[0].PaidDate).format("YYYY-MM-DD"),
    paymentType : data[0].PaymentType,
    cusId : data[0].CusId,
    cusName : data[0].CusName,
    address : data[0].Address,
    depositAccount : data[0].DepositAccount,
    payRefNo : data[0].PayRefNo,
    paidTotal: data[0].PaidTotal,

  });
  
   this.receiptForm.setControl('unpaidInvoices',this.setPaidInvoices(data));


}


  setPaidInvoices(data) : FormArray{
    const paidInvoiceArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      paidInvoiceArray.push(this.fb.group({
        invoiceDate : [ moment(data[i].InvoiceDate).format("YYYY-MM-DD")],
        invoiceNo : [data[i].InvoiceNo],
        invoiceTotal : [data[i].GrandTotal],
        balToPay : [data[i].BalToPay],
        accAmountPaid : [],
        amountPaid : [data[i].AmountPaid],
        select : [true], 
      }));
    }
    return paidInvoiceArray;
  }


  attachFileButtonClick(){
    this.fileUploadService.refNo = this.receiptForm.value.receiptNo;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

    attachReceiptFileButtonClick(item){
      this.fileUploadService.refNo = item.value.invoiceNo;
       const dialogConfig = new MatDialogConfig();
       dialogConfig.disableClose = true;
       dialogConfig.autoFocus = true;
       dialogConfig.width = "75%";
       this.dialogService.openDialog(FileUploadComponent,dialogConfig);
          
      }


      viewInvoiceById(){
        var hasInvoiceNo
        var invoiceNo;  
        hasInvoiceNo=this.route.snapshot.queryParamMap.has('invoiceNo');
         
          if(hasInvoiceNo){
            invoiceNo = this.route.snapshot.queryParamMap.get('invoiceNo')
            this.newButtonClick();  
            this.invoiceService.getAll()
            .subscribe(
               (data) => {
                          var unpaidInvoice = data.filter(obj =>{
                            return obj.InvoiceNo === invoiceNo &&
                            (obj.Status ==='Unpaid' || obj.Status ==='Partially paid');
                          });  
                          this.patchInvoiceValuesToForm(unpaidInvoice); 
                         },
              (err) => 
                       {
                         if(err instanceof HttpErrorResponse){                 
                           if(err.status == 401){
                             this.router.navigate(['/login']);
                           }
                         }
                         console.log(err);
                       }); 
                       
              
                
      }
    
    }
    
     
    patchInvoiceValuesToForm(data){   
      this.receiptForm.patchValue({  
        cusId : data[0].GuestId,
        cusName : data[0].GuestName,
        address : data[0].GuestAddress,
    
      });
      
      this.receiptForm.setControl('unpaidInvoices',this.loadUnpaidInvoices(data));

    }



    savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'portrait',  
        pageMargins: [40, 40, 40, 120],
   
        content: [ 
            
          {
            columns : [ 
              
                    { image:this.logo,            
                      width: 100,
                      height: 100,
                    },
  
                  [                                         
                   {
                    text: 'RECEIPT',
                    color: '#333333',
                    width: '*',
                    fontSize: 30,
                    bold: true,
                    alignment: 'right',
                    margin: [0, 0, 0, 15],
                  },
  
                  {
                   stack: [
                    {
                      columns: [
                        {
                          text: 'Receipt No. :',
                          color: '#aaaaab',
                          bold: true,
                          width: '*',
                          fontSize: 12,
                          alignment: 'right',
                        },
                        {
                          text: this.receiptForm.value.receiptNo,
                          bold: true,
                          color: '#333333',
                          fontSize: 12,
                          alignment: 'right',
                          width: 115,
                        },
                      ],
                    },
                    {
                      columns: [
                        {
                          text: 'Receipt Date :',
                          color: '#aaaaab',
                          bold: true,
                          width: '*',
                          fontSize: 12,
                          alignment: 'right',
                        },
                        {
                          text: moment(this.receiptForm.value.invoiceDate).format("YYYY-MM-DD"),
                          bold: true,
                          color: '#333333',
                          fontSize: 12,
                          alignment: 'right',
                          width: 115,
                        },
                      ],
                    },
  
                  ],
                },
              ],
            ],
          },              
  
          {
            columns : [
           
              [
                
                { text: 'Received From :', margin: [0, 20, 0, 5], color: '#aaaaab',   fontSize: 12,},  
                { text: this.receiptForm.value.cusName,margin: [0, 0, 0, 0], bold:true,   fontSize: 12, },  
                { text: this.receiptForm.value.address,margin: [0, 0, 0, 0] },  
  
              ],
              [
                { text: this.receiptForm.value.paymentType ? `Payment Type : ${this.receiptForm.value.paymentType}` :'' ,width: 'auto',   fontSize: 12,  margin: [15, 40, 0, 0]},
                { text: this.receiptForm.value.payRefNo ? `Payment Ref.No : ${this.receiptForm.value.payRefNo}` :'' ,width: 'auto',   fontSize: 12, margin: [15, 0, 0, 0] },
  
              ],
  
            ]
  
          },
  
          '\n\n',
                             
          {  
            layout: {
              defaultBorder: false,
              hLineWidth: function(i, node) {
                return 1;
              },
              vLineWidth: function(i, node) {
                return 1;
              },
              hLineColor: function(i, node) {
                if (i === 1 || i === 0) {
                  return '#bfdde8';
                }
                return '#eaeaea';
              },
              vLineColor: function(i, node) {
                return '#eaeaea';
              },
              hLineStyle: function(i, node) {
                // if (i === 0 || i === node.table.body.length) {
                return null;
                //}
              },
              // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
              paddingLeft: function(i, node) {
                return 10;
              },
              paddingRight: function(i, node) {
                return 10;
              },
              paddingTop: function(i, node) {
                return 2;
              },
              paddingBottom: function(i, node) {
                return 2;
              },
              fillColor: function(rowIndex, node, columnIndex) {
                return '#fff';
              },
            },
            table: {  
               
                headerRows: 1,  
                widths: ['*', 'auto','auto','auto'],  
                body: [  
                  [
                   { text: 'Invoice Date', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Invoice No', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                   { text: 'Invoice Amount', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},                  
                   { text: 'Received Amount', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                  ...this.getUnpaidInvoices.value.map(p => ([{ text :p.invoiceDate, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},{ text :p.invoiceNo, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'}, {text : this.transformNumberFormat(p.invoiceTotal), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' },{text : this.transformNumberFormat(p.amountPaid), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont'}])),               
                ]           
          }       
        },
  
        '\n',
        '\n',
        {
          columns : [
                    {},
                         
                { 
                  layout: {
                  defaultBorder: false,
                  hLineWidth: function(i, node) {
                    return 1;
                  },
                  vLineWidth: function(i, node) {
                    return 1;
                  },
                  hLineColor: function(i, node) {
                    return '#eaeaea';
                  },
                  vLineColor: function(i, node) {
                    return '#eaeaea';
                  },
                  hLineStyle: function(i, node) {
                    // if (i === 0 || i === node.table.body.length) {
                    return null;
                    //}
                  },
                  // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                  paddingLeft: function(i, node) {
                    return 10;
                  },
                  paddingRight: function(i, node) {
                    return 10;
                  },
                  paddingTop: function(i, node) {
                    return 3;
                  },
                  paddingBottom: function(i, node) {
                    return 3;
                  },
                  fillColor: function(rowIndex, node, columnIndex) {
                    return '#fff';
                  },
                },
                  width: 'auto', 
                  fontSize: 12,            
                  table: {
                  headerRows: 1,
                  widths: ['auto', 'auto'],
                      body: [
                      [
                        {
                          text: 'Paid Total',
                          bold: true,
                          alignment: 'right',
                          border: [false, false, false, true],
                          margin: [0, 5, 0, 5],
                        },
                        {
                          text: this.transformNumberFormat(this.receiptForm.value.paidTotal),
                          bold: true,          
                          alignment: 'right',
                          border: [false, false, false, true],
                          fillColor: '#f5f5f5',
                          margin: [0, 5, 0, 5],
                        },
                      ],
                    ],
                  },
                },         
          ]
  
        },
  
        // '\n','\n','\n',  
        // '\n','\n',
  
    ],  // end content
  
    footer: ()=> {
  
      return [
      
        { margin: [40, 5, 40, 10],canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ]},
        {
          margin: [40, 5, 40, 20],
          columns : [
            [
              { text: 'Address',width: 'auto',bold: true, fontSize: 10},
              { text: this.companyData[0].CompanyName,width: 'auto',bold: true,fontSize: 10 },  
              { text: this.companyData[0].Address,width: 'auto', fontSize: 10 },   
            ],
            [
              
              { text: 'Contact Info',width: '*',bold: true, margin: [20, 0, 0, 0], fontSize: 10},
              { text: this.companyData[0].Phone,width: '*',margin: [20, 0, 0, 0], fontSize: 10 },  
              { text: this.companyData[0].MobileNo,width: '*',margin: [20, 0, 0, 0], fontSize: 10}, 
              { text: this.companyData[0].Email,width: '*',margin: [20, 0, 0, 0], fontSize: 10},
              { text: this.companyData[0].Web,width: '*',margin: [20, 0, 0, 0], fontSize: 10}    
    
            ],
    
            [
              
              { text: 'Bank Details',width: 'auto',bold: true, fontSize: 10},
              { text: 'Bank Name   - Sampath Bank',width: 'auto',fontSize: 10}, 
              { text: `Acc.Name    - Ocean Health and Beauty Center`,width: 'auto',fontSize: 10},   
              { text: `Account No  - 005910001908`,width: 'auto',fontSize: 10},   
              { text: `Branch Name - Bandaragama`,width: 'auto',fontSize: 10} 
    
            ],
    
          ]
        },
    
      ]
      
       },
  
    
    
  
   
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          },
          tableFont: {  
            fontSize: 10,  
             
        
          }       
      } 
        
        
       };// end 
  
  
        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
            
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
          else if(action === 'download'){    
            pdfMake.createPdf(documentDefinition).download(`Payment-${this.receiptForm.value.receiptNo}`);     
        }


    }

    transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }


}
